import {ChronoUnitLegacy} from "utils/time-utils";
import {ReportOptions} from "./component-print-models";
import {Dashboard} from "components/pages/dashboard/components/interfaces";
import {HighlightColor, HighlightRange} from "components/dashboard/product-template-table/utils/interfaces";
import IComponentBaseProps = Dashboard.IComponentBaseProps;
import IComponentTimed = Dashboard.IComponentTimed;
import {DatasetDataInfoResponse} from "api/model/dataset/DatasetDataInfoResponse";

export type DatasetDataInfo = DatasetDataInfoResponse & {
    loadedTime: Date
}

export interface DatasetFullDefaultConfig extends IComponentBaseProps<ReportOptions>, IComponentTimed {
    config?: ComponentConfigDefault;
    datasets?: Array<DatasetDefaultConfig>;
}


export interface TimeConfigDefaultDefined {
    alignStartTo: ChronoUnitLegacy,
    startOffsetUnits: ChronoUnitLegacy,
    startOffset: number,
    lagUnits: ChronoUnitLegacy,
    lagOffset: number,
    leadUnits: ChronoUnitLegacy,
    leadOffset: number
}

export interface ComponentConfigDefault {
    alignStartTo?: ChronoUnitLegacy,
    startOffsetUnits?: ChronoUnitLegacy,
    startOffset?: number,
    lagUnits?: ChronoUnitLegacy,
    lagOffset?: number,
    leadUnits?: ChronoUnitLegacy,
    leadOffset?: number,

    stepUnits?: ChronoUnitLegacy,
    stepSize?: number,

    startAutoRefreshFrequency?: number

    dateFormat?: ChronoUnitLegacy;

    sort?: "ASC" | "DESC";

    itemsPerPage?: number;
    transposed?: boolean;
    showEmpty?: boolean;
    showTotal?: boolean;
    totalType?: "SUM" | "AVG";

    hideDateColumn?: boolean;
}

export interface DatasetDefaultConfig {
    overriddenTitle?: string;
    description?: string;
    identifier: string;
    decimalPlaces?: number;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
    showTotal?: boolean;
    totalType?: "SUM" | "AVG";
}

export interface DatasetOverrideTitleConfig {
    overriddenTitle?: string;
    description?: string;
    title: string;
    unit?: string;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
}

export interface HighlightMapped {
    identifier: string;
    highlightRanges?: Array<HighlightRange>
    defaultHighlight?: HighlightColor
}

export interface IPair {
    key: string;
    value: any;
}

export const mapDatasetDataInfoResponseToDatasetDataInfo = (dataset: DatasetDataInfoResponse) => {
    return {...dataset, loadedTime: new Date()} as DatasetDataInfo
}